import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const suggestionIconStyle: AbgSxProps = (theme) => ({
  backgroundColor: theme.palette.background.tertiary,
});

export const mainContainerStyle: AbgSxProps = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  paddingRight: '8px',
  '& [role="option"]': {
    margin: 0,
  },
};

export const flexOneStyle: AbgSxProps = {
  flex: 1,
};

export const iconColumnStyle: AbgSxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  alignSelf: 'center',
  paddingRight: '8px',
};

export const bookmarkIconButtonStyle: AbgSxProps = {
  color: paletteBase.black,
  padding: 0,
};

export const infoIconButtonStyle: AbgSxProps = {
  color: paletteBase.black,
  padding: 0,
  height: '24px',
  width: '24px',
};

export const avisFirstSuggestionOptionWrapper: AbgSxProps = {
  display: 'inline-flex',
  gap: '8px',
  paddingBlock: '6px',
  paddingInline: '8px',
  alignItems: 'center',
  backgroundColor: '#F3F3F4',
  borderRadius: '4px',
  marginTop: '6px',
  '&:hover': {
    backgroundColor: '#ffffff',
  },
};

export const avisFirstSuggestionAvailabeText: AbgSxProps = {
  color: '#65615D',
  fontSize: '11px',
  lineHeight: '1px',
};
